import React from 'react';
import BrotherCardBase from './BrotherCardBase';

// Board: same member profile as active brothers; position is the eyebrow,
// title case name is the headline.
function BoardCard(props) {
  return (
    <BrotherCardBase
      name={props.name}
      headshot={props.headshot}
      routePrefix="/members"
      eyebrow={props.position}
    />
  );
}

export default BoardCard;
